import { motion } from "framer-motion";
import { getIcon, STATUS } from "@/components/iconMap";

export default function PreLaunchGate({ gate, footer }) {
  return (
    <section data-testid="pre-launch-gate" className="mt-20 border border-white/10 bg-black/40 backdrop-blur-md relative overflow-hidden">
      <div className="absolute inset-0 grid-texture opacity-40" />
      <div className="relative p-6 md:p-10">
        <div className="flex items-center gap-4 mb-10">
          <div className="h-px flex-1 bg-white/10" />
          <h3 data-testid="gate-title" className="font-sans font-semibold uppercase tracking-[0.3em] text-lg md:text-xl text-zinc-100">
            Pre-Launch Gate
          </h3>
          <div className="h-px flex-1 bg-white/10" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {gate.map((item, i) => {
            const Icon = getIcon(item.icon);
            const status = STATUS[item.status] || STATUS.todo;
            const accent = i === 1 ? "#FF6B1A" : "#2E6BFF";
            return (
              <motion.div
                key={item.id}
                data-testid={`gate-item-${i + 1}`}
                className="border border-white/10 p-6 flex flex-col gap-4 bg-[#050505]/60 hover:border-white/25 transition-colors duration-300"
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
              >
                <div className="flex items-center justify-between">
                  <Icon className="w-7 h-7" style={{ color: accent }} strokeWidth={1.5} />
                  <span
                    data-testid={`gate-item-${i + 1}-status`}
                    className="text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 border"
                    style={{ color: status.color, borderColor: `${status.color}55`, backgroundColor: `${status.color}11` }}
                  >
                    {status.label}
                  </span>
                </div>
                <h4 data-testid={`gate-item-${i + 1}-title`} className="font-sans font-bold uppercase text-base" style={{ color: accent }}>
                  {item.title}
                </h4>
                <p className="font-mono text-xs text-zinc-500 leading-relaxed">{item.description}</p>
              </motion.div>
            );
          })}
        </div>

        <p data-testid="footer-motto" className="font-mono text-xs sm:text-sm tracking-[0.5em] text-center text-zinc-400 uppercase mt-12">
          {footer}
        </p>
      </div>
    </section>
  );
}
